import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuVisible: true,
    peopleModel: null,
    eyeDisplay: true,
    bufferGeometry: null,
    queryId: null,
    modelVisible: true,
    labelEyes: false,
    materials: null,
    backgroundColor: '',
    listColor: null,
    meshList: [],
    userInfo: null,
    labelRenderer: null,
    activeMeshId: null,
    orbitControl: null,
    boundingBox: null,
    groupInfo: null,
    toolLabels: false,
    toolAngle: false,
    toolDistance: false,
    selectedChange: false,
    measurementVisible: false,
    rendererRef: null,
    modelReset: false,
    targetDivHtml: null,
    activeModelName: null,
    activeTabName: '1',
  },
  mutations: {
    setModelReset(state, val) { state.modelReset = val },
    setQueryId(state, val) { state.queryId = val },
    setPeopleModel(state, val) { state.peopleModel = val },
    setBufferGeometry(state, val) { state.bufferGeometry = val },
    setMenuVisible(state, val) { state.menuVisible = val },
    setLabelEyes(state, val) { state.labelEyes = val },
    setActiveTabName(state, val) { state.activeTabName = val },
    setTargetDivHtml(state, val) { state.targetDivHtml = val },
    setActiveModelName(state, val) { state.activeModelName = val },
    setToolDistance(state, val) { state.toolDistance = val },
    setToolAngle(state, val) { state.toolAngle = val },
    setToolLabels(state, val) { state.toolLabels = val },
    setGroupInfo(state, val) { state.groupInfo = val },
    setLabelRenderer(state, val) { state.labelRenderer = val },
    setRendererRef(state, val) { state.rendererRef = val },
    setMeasurementVisible(state, val) { state.measurementVisible = val },
    setActiveMeshId(state, val) { state.activeMeshId = val },
    setBoundingBox(state, val) { state.boundingBox = val },
    setOrbitControl(state, val) { state.orbitControl = val },
    setSelectedChange(state, val) { state.selectedChange = val },
    setUserInfo(state, val) { state.userInfo = val },
    setMeshList(state, val) { state.meshList = val },
    setModelVisible(state, val) { state.modelVisible = val },
    setEyeDisplay(state, val) { state.eyeDisplay = val },
    setBackgroundColor(state, val) { state.backgroundColor = val },
    setMaterials(state, val) { state.materials = val },
    setListColor(state, val) { state.listColor = val },
  },
})
